import get from "lodash/get";

/**
 * Ensure user exists.
 */
const ensureUser = async ({ req, res, load, locals, login }, next) => {
  // Require that the user details were loaded.
  // Also checks to see if a users session expired and they didn't click "remember me" on login page.
  if (!get(locals, "activeUser._id")) {
    const token = get(req, "query.auth", false);
    const _id = get(req, "query.id", false);

    // to remove the auth token from the query
    const newPath = req.path.replace(/\bauth\b.*\bmodal\b/, "modal");

    if (token && _id) {
      login({ _id, token }, { refresh: true });
      await load("activeUser", { user: _id });

      delete req.query.token;
      delete req.query._id;
      return res.redirect(newPath);
    }
    return res.redirect("/logout?redirect=" + req.path);
  }
  return next();
};

export default ensureUser;
